import { render, staticRenderFns } from "./QuotationDetails.vue?vue&type=template&id=ca29b6ae&scoped=true&"
import script from "./QuotationDetails.vue?vue&type=script&lang=js&"
export * from "./QuotationDetails.vue?vue&type=script&lang=js&"
import style0 from "lity/dist/lity.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./QuotationDetails.vue?vue&type=style&index=1&id=ca29b6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca29b6ae",
  null
  
)

export default component.exports